/**
 * Created by piotr.pozniak@thebeaverhead.com on 22/09/2022.
 */
import { PLANS } from "../../../../../consts";
import { useCurrentOrganizationStore } from "../../../../../hooks/redux/currentOrganization";
import { hasSubscription } from "../../../helpers/organization";

// Critical per the spec's own definition ("billing failed" is a named
// critical example) — the old UI treated this as a soft warning.
export function useFailedPayment1Alert() {
  const { currentOrganization } = useCurrentOrganizationStore();

  if (!currentOrganization.model) {
    return null;
  }

  const model = currentOrganization.model;
  const subscription = hasSubscription(currentOrganization);

  const failedPayment1 = Number.parseInt(
    model.sent_timestamp_renewal_failed_period_1
  );
  const failedPayment2 = Number.parseInt(
    model.sent_timestamp_renewal_failed_period_2
  );
  const isOnFreePlan = !subscription || subscription.code === PLANS.free;

  if (!failedPayment1 || (failedPayment1 && failedPayment2) || isOnFreePlan) {
    return null;
  }

  return {
    id: "failedPayment1",
    variant: "critical",
    icon: "AlertCircle",
    title: "Payment failed",
    body: "Update billing within 7 days or your account reverts to the free plan.",
    action: { label: "Update billing", to: "/billing" },
  };
}

export default useFailedPayment1Alert;
